export const getRootAttribute = (name: 'au-partner-id' | 'us-partner-id' | 'modal-top-offset') => {
  const root = document.getElementById('freely-widget') as HTMLElement;
  return root?.getAttribute(name);
};
